import { toIsoCountryCodes } from '#lib/country-codes';

export const normalizePortfolioFitCountryCodes = (raw: unknown): string[] => {
  const codes = new Set<string>();

  if (typeof raw === 'string') {
    toIsoCountryCodes(raw).forEach((code) => codes.add(code));
  } else if (Array.isArray(raw)) {
    raw.forEach((entry) => {
      if (typeof entry !== 'string') return;
      toIsoCountryCodes(entry).forEach((code) => codes.add(code));
    });
  }

  return Array.from(codes).sort();
};
